<template>
  <div class="section-block" v-if="!isHiddenLabelRow">
    <div class="section-row"
         :style="{ paddingLeft: rowPaddingLeft, fontSize: rowFontSize }"
         :class="{
           'is-hovered-row': hoveredRow === item.id,
           'no-children':    !item.children || item.children.filter(c => !c.hidden).length === 0
         }"
         @click="item.children ? boardToggleRow(item.id) : null">
      <ChevronDown v-if="item.children && item.children.filter(c => !c.hidden).length > 0"
                   :size="16"
                   class="toggle-icon"
                   :class="{ 'is-open': item.isOpen }" />
      <span class="row-label" v-b-tooltip.hover.bottom="item.Tooltip ? item.Tooltip : undefined">{{ item.label }}</span>
      <span v-if="!item.isLoaded" class="spinner-border spinner-border-sm text-secondary" role="status"></span>
    </div>

    <template v-if="item.isOpen && item.children">
      <MatrixKpiRow v-for="child in item.children.filter(c => !c.hidden)"
                    :key="child.id"
                    :item="child"
                    :depth="depth + 1" />
    </template>
  </div>
</template>

<script>
import { ChevronDown } from 'lucide-vue-next';

export default {
  name: 'MatrixKpiRow',

  components: { ChevronDown },

  inject: ['boardGetHoveredRow', 'boardToggleRow'],

  props: {
    item:  { type: Object, required: true },
    depth: { type: Number, default: 1 },
  },

  computed: {
    isHiddenLabelRow() {
      return this.item.ShowKpiLabelMode
        && this.item.mode === 'kpi'
        && this.item.children
        && this.item.children.length > 0
        && this.item.children.every(c => c.hidden);
    },
    hoveredRow()     { return this.boardGetHoveredRow(); },
    rowPaddingLeft() { return `${0.5 + this.depth * 0.5}rem`; },
    rowFontSize()    { return this.depth >= 4 ? '11px' : '12px'; },
  }
};
</script>

<style lang="scss" scoped>
.section-block {
  display: flex;
  flex-direction: column;
}

.section-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1rem;
  height: 3rem;
  cursor: pointer;
  border-bottom: 1px solid var(--bs-border-color);
  transition: background-color 0.2s ease;

  &:hover {
    background-color: color-mix(in srgb, var(--bs-border-color) 30%, transparent);
  }

  &.no-children {
    cursor: default;

    .row-label {
      margin-left: 1.5rem;
    }
  }

  &.is-hovered-row {
    background-color: color-mix(in srgb, var(--bs-border-color) 30%, transparent) !important;
  }
}

.toggle-icon {
  flex-shrink: 0;
  transition: transform 0.3s ease;
  color: var(--bs-secondary-color);

  &.is-open {
    transform: rotate(180deg);
  }
}

.row-label {
  font-size: 11px;
  font-weight: 500;
  line-height: 1.2;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
